<nav class="submenu-panel" *ngIf="entry" (mouseleave)="onMouseLeave($event)">
    <div class="submenu-panel__header">
        <span class="submenu-panel__title">{{ entry.label }}</span>
        <span class="submenu-panel__sub">Navigate within {{ entry.label }}</span>
    </div>

    <ng-container *ngFor="let section of visibleSections(); let first = first">
        <div class="submenu-panel__section-label"
             *ngIf="section.label"
             [class.submenu-panel__section-label--first]="first">{{ section.label }}</div>

        <ul class="submenu-panel__list">
            <li *ngFor="let item of section.items"
                class="submenu-panel__item"
                [class.active]="isActive(item)"
                [routerLink]="item.routerLink"
                [queryParams]="item.queryParams || null">
                <i [class]="item.icon"></i><span>{{ item.label }}</span>
                <span class="submenu-panel__badge" *ngIf="item.badge">{{ item.badge }}</span>
            </li>
        </ul>
    </ng-container>
</nav>
